// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-2-max-portable-power-station_productcontent__dtzqp"};